export class PayProfile {
    StaffID;
    CompCode;
    CName;
    EName;
    JobTitle;
    EmpType;
    PayTypeCode;
    DateJoin;
    YOS;
    PayGroup;
    PayRate;
    VCR;
    VCE;
    JoinDate;
    constructor() {
        {
            this.StaffID = "";
            this.CompCode = "";
            this.CName = "";
            this.EName = "";
            this.JobTitle = "";
            this.EmpType = "";
            this.PayTypeCode = "";
            this.DateJoin = "";
            this.YOS = "";
            this.PayGroup = "";
            this.PayRate = 0;
            this.VCR = 0;
            this.VCE = 0;
            this.JoinDate = "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/PayProfile.js